
import {Component, Prop, Vue} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';
import {TranslateResult} from "vue-i18n";
import {ExtendedDataLayer} from "default/js/shared/helpers/extended-datalayer";

@Component({
  components: ServiceContainer().getComponents(),
})
export default class extends Vue {
  @Prop() private readonly product: object;
  @Prop({default: () => []}) private stockData: Array<object>;
  @Prop({default: () => 3}) private lowStockOffset: number;
  @Prop({default: () => ''}) private stockText: string;

  private visible: boolean = false;
  private hasBeenOpened: boolean = false;

  private get currentStockData(): Array<object> {
    if (this.isConfigurable) {
      const selectedProducts = this.selectedProduct;
      if (selectedProducts && selectedProducts.length === 1) {
        const product = selectedProducts[0];
        const sourceItems = this.stockData.map(item => {
          return {
            name: item['name'],
            stock_overwrite_message: item['stock_overwrite_message'],
            url: item['url'],
            quantity: product['source_item_' + item['inventory_source_code'] + '_quantity'],
            status: product['source_item_' + item['inventory_source_code'] + '_status'],
          };
        });

        return sourceItems;
      }
    }
    return this.stockData;
  }

  private get isConfigurable(): boolean {
    return this.product && this.product['product_type'] === 'configurable';
  }

  private get selectedProduct(): Array<object> {
    return this.$store.getters['CatalogConfigurableProduct/selectedProducts'];
  }

  private getStockLabel(quantity: number): TranslateResult {
    if (quantity < 1) {
      return this.$t('Out of stock');
    }
    if (quantity <= this.lowStockOffset) {
      return this.$t('Low stock');
    }
    return this.$t('{count} items in stock', {count: quantity});
  }

  private getStockClass(quantity: number): string {
    if (quantity < 1) {
      return 'out-of-stock';
    }
    return (quantity <= this.lowStockOffset) ? 'low-stock' : 'in-stock';
  }

  private toggleVisibility() {
    if(!this.hasBeenOpened) {
      new ExtendedDataLayer().addViewStoreStock(this.product);
      this.hasBeenOpened = true;
    }

    this.visible = !this.visible;
  }
}

